export default "__VITE_ASSET__WD$jzmGA__"